import { useContext } from "react";
import CustomDrawer from "../common/CustomDrawer";
import { LeftDrawerContext } from "../context/LeftDrawerContext";

const LeftDrawer = () => {
  const { open, content } = useContext(LeftDrawerContext);

  return <CustomDrawer children={content} open={open} anchor="left" />;
};

export default LeftDrawer;
